module.exports = __webpack_public_path__ + "static/media/Play.c12f5f37.svg";